module.exports = __webpack_public_path__ + "img/leisure_getaways.f5cd6b3d.svg";